import React from 'react';
import { Search, User, Menu } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';

export const Header: React.FC = () => {
  const { user } = useAuth();
  const { bgClass } = useTheme();

  return (
    <header className={`sticky top-0 z-40 w-full border-b border-black/5 dark:border-white/5 backdrop-blur-md ${bgClass} bg-opacity-90`}>
      <div className="max-w-4xl mx-auto px-4 h-14 flex items-center justify-between">
        
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
           <span className="font-serif font-bold text-xl tracking-tight">Readsy.</span>
        </Link>

        {/* Actions */}
        <div className="flex items-center gap-4">
          <Link to="/search" className="p-2 -mr-2 text-inherit opacity-70 hover:opacity-100">
            <Search size={20} />
          </Link>
          
          <Link to={user ? "/profile" : "/library"} className="p-2 -mr-2 text-inherit opacity-70 hover:opacity-100">
            {user ? (
               <div className="w-6 h-6 rounded-full bg-brand-blue flex items-center justify-center text-white text-xs font-bold">
                 {user.name?.charAt(0)}
               </div>
            ) : (
               <User size={20} />
            )}
          </Link>
        </div>
      </div>
    </header>
  );
};